export default __webpack_public_path__ + "static/media/04.b13906d4.png";